module.exports = __webpack_public_path__ + "media/difficult-conversation-1080.3f2b371e.mp4";